import React from 'react';
import { Lightbulb, Play, Target } from 'lucide-react';

const HowIWork = () => {
  const steps = [
    {
      number: "01",
      icon: Lightbulb,
      title: "Develop",
      subtitle: "Concept & narrative",
      description: "From initial concept to production-ready scripts, I shape stories that resonate across formats and audiences."
    },
    {
      number: "02",
      icon: Play,
      title: "Produce",
      subtitle: "Execution & delivery",
      description: "Leading creative teams and managing production end-to-end—from small-scale content to large-scale live experiences."
    },
    {
      number: "03",
      icon: Target,
      title: "Position",
      subtitle: "Audience & distribution",
      description: "Strategic programming, festival positioning, and audience engagement to maximize reach and impact."
    }
  ];

  return (
    <section id="how-i-work" className="py-20 bg-[#DDE3EC] relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-1/2 h-1/2 bg-gradient-to-br from-whale-blue/7 to-transparent"></div>
      
      <div className="container mx-auto px-8 md:px-16 relative z-10">
        <div className="max-w-7xl mx-auto">
          {/* Section header */}
          <div className="text-center mb-16">
            <h2 className="text-[20px] tracking-[0.2em] uppercase text-midnight-blue font-montserrat font-bold mb-6">
              How I Work
            </h2>
            <h2 className="font-playfair font-bold text-3xl md:text-4xl text-whale-blue mb-4">
              Full-Cycle Creative Value
            </h2>
          </div>

          {/* Process steps */}
          <div className="grid md:grid-cols-3 gap-8">
            {steps.map((step, index) => {
              const Icon = step.icon;
              return (
                <div
                  key={index}
                  className="group relative bg-white p-8 rounded-sm border-2 border-whale-blue/12 hover:border-[#818BB1]/30 transition-all duration-300 shadow-lg hover:shadow-2xl"
                >
                  {/* Number label */}
                  <div className="absolute top-6 right-6 font-playfair font-bold text-6xl group-hover:text-[#818BB1]/30 transition-colors" style={{ color: '#872D37' }}>
                    {step.number}
                  </div>

                  {/* Icon */}
                  <div className="mb-6">
                    <div className="w-16 h-16 rounded-full bg-[#818BB1]/10 group-hover:bg-[#818BB1]/20 flex items-center justify-center transition-colors">
                      <Icon className="w-8 h-8 text-[#818BB1] group-hover:text-[#818BB1] transition-colors" strokeWidth={1.5} />
                    </div>
                  </div>

                  {/* Content */}
                  <h3 className="font-playfair font-bold text-2xl text-midnight-blue mb-2 group-hover:text-whale-blue transition-colors">
                    {step.title}
                  </h3>
                  <p className="text-sm text-whale-blue font-semibold uppercase tracking-wider mb-4">
                    {step.subtitle}
                  </p>
                  <p className="text-charcoal/70 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowIWork;
